<template>
  <div class="layoutDialog">
    <div class="dialog">
      <p v-if="dialogData.title" class="dialog_top">{{ dialogData.title }}</p>
      <p class="dialog_con">
        {{ dialogData.content }}
      </p>
      <div class="dialog_fotter">
        <p class="confirm" @click="dialogData.confirmCb" v-if="dialogData.confirmText">{{ dialogData.confirmText }}</p>
        <p class="cancel" v-if="dialogData.cancelText">{{ dialogData.cancelText }}</p>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>
<script>
export default {
  name: "layoutDialog",
  props: {
    dialogData: Object
  }
};
</script>
<style scoped lang="less">
.layoutDialog {
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100vw;
    background: rgba(0, 0, 0, 0.8);
  }

  .dialog {
    width: 80%;
    background: #fff;
    border-radius: .2rem;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    padding: .4rem .3rem;
    box-sizing: border-box;

    .dialog_top {
      margin-bottom: .3rem;
      font-size: .32rem;
      color: #000;
      text-align: center;
    }

    .dialog_con {
      font-size: .24rem;
      line-height: .3rem;
      color: #000;
      margin-bottom: .4rem;
    }

    .dialog_fotter {
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        width: 48%;
        height: .68rem;
        line-height: .68rem;
        text-align: center;
        border-radius: .08rem;
        font-size: .22rem;
      }

      .cancel {
        border: .02rem solid #979797;
        color: #999;
        font-weight: 500;
      }

      .confirm {
        color: #fff;
        font-weight: 500;
        background: #009E60;
      }
    }
  }
}
</style>
